module.exports = __webpack_public_path__ + "static/media/logo-black.4fd8020d.png";